(function (factory) {
	if (typeof define === "function" && define.amd) {
		define(["./dependencyLibs/inputmask.dependencyLib", "./inputmask"], factory);
	} else if (typeof exports === "object") {
		module.exports = factory(require("./dependencyLibs/inputmask.dependencyLib"), require("./inputmask"));
	} else {
		factory(window.dependencyLib || jQuery, window.Inputmask);
	}
}
(function ($, Inputmask) {
	// Source: https://github.com/RobinHerbots/Inputmask

	// Override default values
	$.extend(true, Inputmask.prototype.defaults, {
		greedy: false,
		placeholder: ' '
	});

	// Remove the default definitions
	Inputmask.prototype.definitions = {};

	// Set our custom definitions
	Inputmask.extendDefinitions({
		'#': {
			validator: "[\\d]",
			cardinality: 1,
		},
		'a': {
			validator: "[\\D]",
			cardinality: 1,
		},
		'*': {
			validator: "[0-9\\uff11-\\uff19A-Za-z\\u0410-\\u044f\\u0401\\u0451\\xc0-\\xff\\xb5]",
			cardinality: 1,
		}
	});
	return Inputmask;
}));
